export const URL_BASE = process.env.API_BASE_URL;


// WEBPACK FOOTER //
// ./src/helper/constants.js